import type { Money } from "@workspace/model"

/**
 * ISO-4217 minor-unit exponents that differ from the usual 2. `Money.amount`
 * is in minor units, so a blind `/ 100` would misreport e.g. JPY by 100x.
 */
const ZERO_DECIMAL = new Set([
  "BIF",
  "CLP",
  "DJF",
  "GNF",
  "ISK",
  "JPY",
  "KMF",
  "KRW",
  "PYG",
  "RWF",
  "UGX",
  "UYI",
  "VND",
  "VUV",
  "XAF",
  "XOF",
  "XPF",
])
const THREE_DECIMAL = new Set(["BHD", "IQD", "JOD", "KWD", "LYD", "OMR", "TND"])

export function currencyExponent(currency: string): number {
  const code = currency.toUpperCase()
  if (ZERO_DECIMAL.has(code)) return 0
  if (THREE_DECIMAL.has(code)) return 3
  return 2
}

/** Major units for a minor-unit amount, rounded to the currency's precision. */
export function toMajor(amount: number, currency: string): number {
  const exponent = currencyExponent(currency)
  return Number((amount / 10 ** exponent).toFixed(exponent))
}

export function minorToMajor(money: Money): number {
  return toMajor(money.amount, money.currency)
}
